import axiosInstance from './AxiosInstance';

export const getMonthlyStats = async () => {
  const response = await axiosInstance.get('/graph/monthly-stats');
  return response.data;
};
